import { Alert, Button, Flex } from "@aws-amplify/ui-react";
import moment from "moment";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { dateToYYMMDD } from "../../libs/shared/utils/dates.util";

export default function InquiryNotPossibleSection({
  arrival,
  departure,
}: {
  arrival?: string;
  departure?: string;
}) {
  const { t } = useTranslation();

  const queryString = useMemo(() => {
    if (moment(arrival).isBefore(moment())) {
      return `?arrival=${dateToYYMMDD(moment())}&departure=${departure}`;
    }

    if (moment(departure).isBefore(moment())) {
      return ``;
    }

    return `?arrival=${arrival}&departure=${departure}`;
  }, [arrival, departure]);

  return (
    <Flex direction={"column"}>
      <Alert variation="error" grow={1}>
        {t("GuestReservation.InquiryNotPossible")}
      </Alert>

      <Button variation={"primary"} as="a" href={`/${queryString}`}>
        {t("GuestReservation.InquiryNotPossibleCTA")}
      </Button>
    </Flex>
  );
}
